import * as utils from '@utils/form';
import { iframeRegex, textEditorValidator } from '@utils/validator';
import { IMAGE_SIZE } from '@api/media/constants';

export const FORM_FIELDS = {
  IMAGE: {
    name: 'thumbnailImage',
    label: 'Video thumbnail:',
    rules: [{ required: true, message: 'An image is required' }],
    size: IMAGE_SIZE['800x450'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
  TIME: {
    name: 'time',
    label: 'Time:',
    placeholder: 'Write a time for the video...',
  },
  TITLE: {
    name: 'title',
    label: 'Title:',
    placeholder: 'Write a title for the video...',
    rules: [{ required: true, message: 'Title is required' }],
  },
  DESCRIPTION: {
    name: 'description',
    label: 'Description:',
    rules: [{ validator: textEditorValidator, message: '250 characters maximum' }],
  },
  VIDEO: {
    name: 'video',
    label: 'Embed code:',
    placeholder: 'Enter the HTML snipet',
    rules: [
      { required: true, message: 'Embed code is required' },
      { pattern: iframeRegex, message: "Doesn't look like a valid Embed code" },
    ],
  },
};

export const MODULE_FIELDS = {
  VIDEOS: {
    name: 'videos',
    label: 'Current videos',
    rules: [{ min: 1, max: 8 }],
  },
  TITLE: {
    name: 'title',
    label: 'Module Title:',
    placeholder: 'Write a title for the module...',
    rules: [{ required: true, message: 'Module title is required' }],
  },
  DESCRIPTION: {
    name: 'description',
    label: 'Module Description:',
    placeholder: 'Write a description for the module...',
  },
};
